import SettingsItem from 'components/SettingsItem';
import React from 'react';
import permissionService from 'services';

interface DefaultViewSettingWrapperProps {
    defaultView: string;
    isDesktop: boolean;
    handleDefaultViewChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const DefaultViewSettingWrapper = ({ defaultView, isDesktop, handleDefaultViewChange }: DefaultViewSettingWrapperProps) => (
    <SettingsItem
        inputType='select'
        customOptions={[
            ...(permissionService.haveAccessToView('news') ? [{ value: 'Akt', label: 'Aktualności' }] : []),
            ...(permissionService.haveAccessToView('orders') ? [{ value: 'Zam', label: 'Zamówienia' }] : []),
            ...(permissionService.haveAccessToView('new-order') ? [{ value: 'NZam', label: 'Nowe zamówienie' }] : []),
            ...(permissionService.haveAccessToView('settlements') ? [{ value: 'Roz', label: 'Rozliczenia' }] : []),
            ...(permissionService.haveAccessToView('promotions') ? [{ value: 'Wsp', label: 'Wspólne korzyści' }] : []),
            ...(permissionService.haveAccessToView('isod') ? [{ value: 'Isod', label: 'Isod' }] : []),
            ...(permissionService.haveAccessToView('account') ? [{ value: 'Konto', label: 'Konto' }] : []),
            ...(permissionService.haveAccessToView('admin') ? [{ value: 'Adm', label: 'Admin' }] : []),
            ...(permissionService.haveAccessToView('additional-tab') ? [{ value: 'Kon', label: 'Konkursy' }] : []),
            ...(permissionService.haveAccessToView('settings') ? [{ value: 'Ust', label: 'Ustawienia' }] : [])
        ]}
        id='defaultView'
        value={defaultView}
        changeHandler={handleDefaultViewChange}
        additionalStyles={{ width: isDesktop ? '300px' : '220px', height: '37px', fontSize: '1rem !important' }}

    />
);

export default DefaultViewSettingWrapper;
